/**
 * Per-session tracking of whether a multi-org user has picked their active
 * organization yet. Used to enforce the "Select organization" step on every
 * login for users who belong to more than one organization.
 *
 * The flag lives in localStorage (changed from sessionStorage) so it persists
 * across tabs in the same browser session. This prevents the "Select organization"
 * screen from appearing when users open links in new tabs. The flag is explicitly
 * cleared on logout so a re-login re-triggers the selector.
 */
const ORG_SELECTED_SESSION_KEY = "apqa.orgSelectedThisSession";

export const markOrgSelectedForSession = (): void => {
  try {
    localStorage.setItem(ORG_SELECTED_SESSION_KEY, "1");
  } catch {
    /* localStorage unavailable (private mode / SSR) — non-critical */
  }
};

export const hasSelectedOrgThisSession = (): boolean => {
  try {
    return localStorage.getItem(ORG_SELECTED_SESSION_KEY) === "1";
  } catch {
    return false;
  }
};

export const clearOrgSelectedForSession = (): void => {
  try {
    localStorage.removeItem(ORG_SELECTED_SESSION_KEY);
  } catch {
    /* non-critical */
  }
};
